/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateStandardtaskDto } from '../models/work-create-standardtask-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkStandardtask } from '../models/work-standardtask';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateStandardtaskDto } from '../models/work-update-standardtask-dto';

@Injectable({ providedIn: 'root' })
export class WorkStandardtasksV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `standardtasksV2ControllerFindAllPaginated()` */
  static readonly StandardtasksV2ControllerFindAllPaginatedPath = '/v2/standardtasks';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerFindAllPaginated$Response(
    params?: {
      withContainerType?: boolean;
      withTaskType?: boolean;
      withTaskGroup?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by showInMontageplan query param.
     *           <p>
     *              <b>Format: </b> filter.showInMontageplan={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.showInMontageplan=$not:$like:John Doe&filter.showInMontageplan=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.showInMontageplan'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>containertypeId</li>
     * <li>tasktypeId</li>
     * <li>taskgroupId</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'tasktypeId:ASC' | 'tasktypeId:DESC' | 'taskgroupId:ASC' | 'taskgroupId:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkStandardtask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'showInMontageplan'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withContainerType', params.withContainerType, {});
      rb.query('withTaskType', params.withTaskType, {});
      rb.query('withTaskGroup', params.withTaskGroup, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.showInMontageplan', params['filter.showInMontageplan'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkStandardtask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'showInMontageplan'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerFindAllPaginated(
    params?: {
      withContainerType?: boolean;
      withTaskType?: boolean;
      withTaskGroup?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by showInMontageplan query param.
     *           <p>
     *              <b>Format: </b> filter.showInMontageplan={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.showInMontageplan=$not:$like:John Doe&filter.showInMontageplan=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.showInMontageplan'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>containertypeId</li>
     * <li>tasktypeId</li>
     * <li>taskgroupId</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'tasktypeId:ASC' | 'tasktypeId:DESC' | 'taskgroupId:ASC' | 'taskgroupId:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkStandardtask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'showInMontageplan'?: (string | Array<string>);
};
};
}> {
    return this.standardtasksV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkStandardtask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'showInMontageplan'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkStandardtask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'showInMontageplan'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerCreate()` */
  static readonly StandardtasksV2ControllerCreatePath = '/v2/standardtasks';

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardtasksV2ControllerCreate$Response(
    params: {
      body: WorkCreateStandardtaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStandardtask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStandardtask>;
      })
    );
  }

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardtasksV2ControllerCreate(
    params: {
      body: WorkCreateStandardtaskDto
    },
    context?: HttpContext
  ): Observable<WorkStandardtask> {
    return this.standardtasksV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStandardtask>): WorkStandardtask => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerGetAllDropdownOptions()` */
  static readonly StandardtasksV2ControllerGetAllDropdownOptionsPath = '/v2/standardtasks/dropdownOptions';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetAllDropdownOptions$Response(
    params?: {

    /**
     * Nur Standardtasks dieses Tasktyps (z. B. 1 = Aufgabe).
     */
      tasktypeId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
      rb.query('tasktypeId', params.tasktypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetAllDropdownOptions(
    params?: {

    /**
     * Nur Standardtasks dieses Tasktyps (z. B. 1 = Aufgabe).
     */
      tasktypeId?: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.standardtasksV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerGetAllDropdownOptionsByContainertypeId()` */
  static readonly StandardtasksV2ControllerGetAllDropdownOptionsByContainertypeIdPath = '/v2/standardtasks/dropdownOptions/{containertypeId}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerGetAllDropdownOptionsByContainertypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetAllDropdownOptionsByContainertypeId$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerGetAllDropdownOptionsByContainertypeIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerGetAllDropdownOptionsByContainertypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetAllDropdownOptionsByContainertypeId(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.standardtasksV2ControllerGetAllDropdownOptionsByContainertypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeId()` */
  static readonly StandardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeIdPath = '/v2/standardtasks/dropdownOptionsAppointments/{containertypeId}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeId$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeId(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.standardtasksV2ControllerGetDropdownOptionsAppointmentsByContainertypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerGetVisibleInMontageplan()` */
  static readonly StandardtasksV2ControllerGetVisibleInMontageplanPath = '/v2/standardtasks/visibleInMontageplan';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerGetVisibleInMontageplan()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetVisibleInMontageplan$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkStandardtask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerGetVisibleInMontageplanPath, 'get');
    if (params) {
      rb.query('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkStandardtask>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerGetVisibleInMontageplan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerGetVisibleInMontageplan(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkStandardtask>> {
    return this.standardtasksV2ControllerGetVisibleInMontageplan$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkStandardtask>>): Array<WorkStandardtask> => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerFindOneById()` */
  static readonly StandardtasksV2ControllerFindOneByIdPath = '/v2/standardtasks/{id}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerFindOneById$Response(
    params: {
      id: number;
      withDocumenttypes?: boolean;
      withWorkflows?: boolean;
      withWorkflowtasks?: boolean;
      withReservationtypes?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStandardtask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withDocumenttypes', params.withDocumenttypes, {});
      rb.query('withWorkflows', params.withWorkflows, {});
      rb.query('withWorkflowtasks', params.withWorkflowtasks, {});
      rb.query('withReservationtypes', params.withReservationtypes, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStandardtask>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerFindOneById(
    params: {
      id: number;
      withDocumenttypes?: boolean;
      withWorkflows?: boolean;
      withWorkflowtasks?: boolean;
      withReservationtypes?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkStandardtask> {
    return this.standardtasksV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStandardtask>): WorkStandardtask => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerDelete()` */
  static readonly StandardtasksV2ControllerDeletePath = '/v2/standardtasks/{id}';

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardtasksV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.standardtasksV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `standardtasksV2ControllerUpdate()` */
  static readonly StandardtasksV2ControllerUpdatePath = '/v2/standardtasks/{id}';

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardtasksV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardtasksV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateStandardtaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStandardtask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStandardtasksV2Service.StandardtasksV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStandardtask>;
      })
    );
  }

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardtasksV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardtasksV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateStandardtaskDto
    },
    context?: HttpContext
  ): Observable<WorkStandardtask> {
    return this.standardtasksV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStandardtask>): WorkStandardtask => r.body)
    );
  }

}
